import Image from 'next/image';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';

import No2FAImage from '@/assets/images/profile/no-2fa.svg';
import YlahFullLogo from '@/assets/images/ylah-full-logo.svg';
import Link from '@/components/Link';
import useGetMe from '@/hooks/api/me/useGetMe';
import useGetTotp from '@/hooks/api/profile/useGetTotp';

import Button from '../Button';
import { CONFIGURE_TOTP_PATH } from '../Profile/ProfileConfigureTotp/ConfigureLinkButton';
import styles from './Required2FAOverlay.module.scss';

const SKIP_PATHS = [
  '/welcome',
  '/onboarding',
  '/policies',
  '/institution-not-found',
  '/institution-select',
];

export function Required2FAOverlay() {
  const { t } = useTranslation('common');
  const { pathname } = useRouter();

  const shouldFetch = !SKIP_PATHS.includes(pathname);

  const { data, isPending: isPendingMe } = useGetMe(shouldFetch);
  const { totp, isPending: isPendingTotp } = useGetTotp(shouldFetch);

  const isPending = useMemo(
    () => isPendingMe || isPendingTotp,
    [isPendingMe, isPendingTotp]
  );

  if (
    isPending ||
    SKIP_PATHS.includes(pathname) ||
    !data?.twoFactorAuthRequired ||
    (data?.twoFactorAuthRequired && totp && totp?.length > 0)
  ) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Image src={YlahFullLogo} width={280} alt={''} />
      <div className={styles.content}>
        <Image src={No2FAImage} width={255} height={255} alt={''} />
        <h1 className={styles.header}>{t('2fa-overlay.title')}</h1>
        <p className={styles.description}>{t('2fa-overlay.description')}</p>
        <Link
          href={CONFIGURE_TOTP_PATH}
          underline={false}
          disableHover
          isInline
          className={styles.buttonLink}
        >
          <Button text={t('2fa-overlay.button')} />
        </Link>
        <Link id="log-out-link" href="/api/auth/sign-out">
          {t('log-out')}
        </Link>
      </div>
    </div>
  );
}
